import React, { FC } from 'react';
import styled from 'styled-components';
import { CoreTheme as theme } from '@minecraft.themes';
import Icon from '@minecraft.icon';
import { PageWrapperStyles } from '../../../common/styles';

const HeaderWrapper = styled.div`
  ${PageWrapperStyles}

  align-items: center;
  border-bottom: 0.0625rem solid rgb(58, 58, 58);
  display: flex;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;

export const StageName = styled.h1`
  color: ${(props): string => props.theme.colors.primary.white};
  margin: 0;
  margin-right: 2rem;
  font-size: 1.5rem;
`;

const CloseIcon = styled(Icon)`
  width: 1rem;
  height: 1rem;
  cursor: pointer;
`;

type Props = {
  stageName: string;
  toggleOverlay: () => void;
};

const QuickViewOverlayHeader: FC<Props> = ({ stageName, toggleOverlay }) => {
  return (
    <HeaderWrapper>
      <StageName>{stageName}</StageName>
      <CloseIcon onClick={toggleOverlay} name="close" color={theme.colors.primary.white} />
    </HeaderWrapper>
  );
};

export default QuickViewOverlayHeader;
